/*=========================================================================================
  File Name: module-auth-actions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import LoginAPI from '../../api/LoginAPI';
import httpClient from '../../api/axios-httpclient';
export default {
	logoutApp: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: LoginAPI.getAPIUrl() + '/logout',
				data: payload
			},
			true
		);

		if (res.Success) {
			return res.Data;
		}

		return res;
	},
	// thực hiện lấy thông tin cached của bên tích hợp
	getCacheLogin: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: LoginAPI.getAPIUrl() + '/logininfo',
				params: payload
			},
			true
		);

		return res;
	},

	//Thực hiện login vào hệ thống qua sessionid của amis
	exchangeSession: async function() {
		let res = await httpClient.getAsync(
			{
				url: LoginAPI.getAPIUrl() + '/exchange-session'
			},
			true,
			false
		);
		if (res && res.Success && res.Data) {
			return res.Data;
		}
		return null;
	},

	setIsLaterState: function(context, value) {
		context.commit('updateIsLaterState', value);
	},
	setTimeoutAccountActive: function(context, value) {
		context.commit('updateTimeout', value);
	},
	setIsShowWarningLisence: function(context, value) {
		context.commit('updateIsShowWarningLisence', value);
	}
};
